var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangePlanSub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.6 37.8",
    style: {
      enableBackground: "new 0 0 39.6 37.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,17.6l-1.4-1.4l-1.3,1.3c0.6-4.6,3.3-8.7,7.3-11.1c2.5-1.5,5.3-2.1,8.1-1.9v-2C11.7,2.1,4.1,8.6,3.1,17.4 l0,0l-1.3-1.3l-1.4,1.4L4,21.1L7.8,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.5,16.8l-3.6,3.6l1.4,1.4l1.2-1.2c-0.5,4.7-3.1,8.8-7.1,11.2c-2.2,1.3-4.6,2-6.9,2.1v2 c8.4-0.3,15.4-6.8,16.1-15.4l1.3,1.3l1.4-1.4L35.5,16.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.2,
    y: 19.8,
    className: "st0",
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 20.8,
    className: "st0",
    width: 6.8,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.2,
    y: 25.4,
    className: "st0",
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 26.5,
    className: "st0",
    width: 6.8,
    height: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.2,27.3h-1.8v-10h14v1.1h2v-5.1c0-0.5-0.2-1-0.6-1.4c-0.4-0.4-0.8-0.6-1.4-0.6h-1v-2h-2v2h-8v-2h-2v2h-1 c-0.5,0-1,0.2-1.4,0.6c-0.4,0.4-0.6,0.8-0.6,1.4v14c0,0.5,0.2,1,0.6,1.4c0.4,0.4,0.8,0.6,1.4,0.6h1.8V27.3z M12.4,13.3h14v2h-14 V13.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePlanSub);
export default __webpack_public_path__ + "static/media/change-plan-sub.c77234c81d0475abc24d246eea49592b.svg";
export { ForwardRef as ReactComponent };